import { render, staticRenderFns } from "./Box3D.vue?vue&type=template&id=786e3cfa&"
import script from "./Box3D.vue?vue&type=script&lang=ts&"
export * from "./Box3D.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports